module.exports = __webpack_public_path__ + "88f38f33e9c5dd75280aadbd2b8d60a5.svg";